export default "__VITE_ASSET__CHzeON8z__"